import anime from "animejs/lib/anime.es.js";
import "intersection-observer";

/*
 *
 * Animations Module
 * @notes Needs lots of work to make it more general
 *
 */

class Animations {
  constructor() {
    const animatedElements = document.querySelectorAll(".animate");
    
    let isLeaving = false;
  
    //a generic insersection observer offset
    const offSet = - (window.innerHeight * 0.2);
    const options = {
      rootMargin: "0px 0px " + offSet + "px 0px",
    };
  
    const callback = function (entries,observer) {
      entries.forEach((entry) => {
        //load options from element
  
        const options = JSON.parse(entry.target.dataset.animation);
  
  
        //some options need converting to functions
        if (options.delay) options.delay = anime.stagger(options.delay);
  
        let targets = document.querySelectorAll(options.targets);
  
        for (let i = 0; i < targets.length; i++) {
          if (options.fromLeft > 0) targets[i].style.left = - options.fromLeft + "px";
          if (options.fromRight > 0) targets[i].style.right = - options.fromRight + "px";
          if (options.fromTop) targets[i].style.top = - options.fromTop + "px";
          if (options.fromBottom) targets[i].style.bottom = - options.fromBottom + "px";
          if (options.fadeIn) targets[i].style.opacity = 0;
        }
  
        if (options.fromLeft > 0) options.left = "+=" + options.fromLeft;
        if (options.fromRight > 0) options.right = "+=" + options.fromRight;
        if (options.fromTop > 0) options.top = "+=" + options.fromTop;
        if (options.fromBottom > 0) options.bottom = "+=" + options.fromBottom;
  
        //Use anime.js
        if (options.fadeIn) options.opacity = 1;
        
        if (entry.isIntersecting) {
          isLeaving = true;
  
          anime(options);
          
          observer.unobserve(entry.target);
          //check foir parallax
        if (entry.target.classList.contains('parallax')) {
          document.addEventListener('scroll',() => {
            //0 when it hits top of window
            let fromTopOfWindow = entry.target.getBoundingClientRect().top;
  
            //item height
            let itemHeight = entry.target.offsetHeight;
  
            //height of window
            let windowHeight = window.innerHeight;
  
            //bigger than 0 = working
            let triggerPoint = fromTopOfWindow-(windowHeight*0.5);
   
            let percentageShift = ((triggerPoint*-1 / itemHeight)*100);
  
            //if we've passed the trigger point and scrolling within
            if (percentageShift >= 0 && percentageShift <= 60) {
              entry.target.style.backgroundPosition = `50% ${percentageShift}%`;
            }
  
            if (triggerPoint < itemHeight*-1) {
              entry.target.style.backgroundPosition = `50% 60%`;
              document.removeEventListener('scroll',this);
            }
            
          },true);
        }
          
        } else if (isLeaving) {
          isLeaving = false;
        }
      });
    };
  
    const observer = new IntersectionObserver(callback, options);
  
    for (let i = 0; i < animatedElements.length; i++) {
      observer.observe(animatedElements[i]);
    }
  }
}

export default new Animations;
